import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://jdlcjehnjkmdioivpasb.supabase.co'
const supabaseAnonKey = 'sb_publishable_9oV8pa5hh4lHXs2-Z4dxug_tML2V1yx'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)